import { TextInput } from "src/Components";
import { ITimeConfig } from "src/Interfaces/deltaHedgeBackTest";

interface IProps {
  timeConfig: ITimeConfig;
  onChange: (name: string, value: any) => void;
  profileName?: string;
}

const TimeConfig = ({ onChange, timeConfig, profileName }: IProps) => {
  return (
    <div className="flex flex-col justify-start items-start gap-3">
      <div className="font-bold text-xs">تنظیمات بک تست</div>
      <div className="flex flex-col justify-start items-start gap-3 border border-gray-300 rounded p-3">
        {profileName ? (
          <TextInput
            label=""
            name="profileName"
            onChange={() => {}}
            disabled
            value={profileName}
            extraLabel
          />
        ) : (
          <></>
        )}
        <TextInput
          label="حداقل % TE"
          name="minTE"
          value={timeConfig.minTE}
          onChange={onChange}
          kind="percent"
          extraLabel
        />
        <TextInput
          label="حداقل DEI"
          name="minDEI"
          value={timeConfig.minDEI}
          onChange={onChange}
          extraLabel
        />

        <TextInput
          label="دقت(دقیقه)"
          name="resolutionInMins"
          value={timeConfig.resolutionInMins}
          onChange={onChange}
          extraLabel
        />
        <TextInput
          label="پنجره(روز)"
          name="windowLengthInDays"
          value={timeConfig.windowLengthInDays}
          onChange={onChange}
          extraLabel
        />
      </div>

    </div>
  );
};

export default TimeConfig;
